import angular from "angular"
import "../edition/edition"
import "../productCategory/productCategory"
import "../autocomplete/autocomplete"

export default angular.module("vehicleModule", ["editionModule", "productCategoryModule", "autocompleteModule"])